var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getType(_vm.field.type),{ref:"component",tag:"component",attrs:{"fieldData":_vm.field}})}
var staticRenderFns = []

export { render, staticRenderFns }